import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import GitHubIcon from './GitHubIcon';
import LinkedInIcon from './LinkedInIcon';
import BuyMeACoffeeImage from './BuyMeACoffeeImage';
import YahooAttribution from './YahooAttribution';
import { useAttribution } from './AttributionContext';
import { providerFromPathname, providerRequiresAttribution } from '../utils/providerPolicy';

/**
 * Site-wide footer.  Mounted once in App.js below the routes.
 *
 * The Yahoo attribution line appears whenever the current page shows Yahoo
 * data: league-scoped routes carry the provider in the URL; the dashboard and
 * shared-league pages report their providers through AttributionContext.
 */
const Footer = () => {
  const location = useLocation();
  const { providers } = useAttribution();
  const routeProvider = providerFromPathname(location.pathname);
  const showYahoo =
    providerRequiresAttribution(routeProvider) ||
    (providers || []).some(providerRequiresAttribution);

  return (
    <footer className="bg-surface border-t border-border mt-auto" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col items-center gap-4">
        {showYahoo && <YahooAttribution />}
        <p className="text-text-muted text-xs font-semibold text-center">
          For suggestions or feature requests, please connect with us on GitHub or LinkedIn.
        </p>
        <div className="flex items-center gap-4">
          <GitHubIcon />
          <LinkedInIcon />
        </div>
        <BuyMeACoffeeImage />
        <nav className="flex items-center gap-4 text-xs font-semibold text-text-muted">
          <Link to="/privacy" className="hover:text-text transition-colors">
            Privacy Policy
          </Link>
          <Link to="/methodology" className="hover:text-text transition-colors">
            Methodology
          </Link>
          <Link to="/contact/" className="hover:text-text transition-colors">
            Contact
          </Link>
        </nav>
        <p className="text-text-muted text-xs text-center mt-1">
          Doritostats is not affiliated with, endorsed by, or connected to Frito-Lay, PepsiCo, or the Doritos® brand. Doritos® is a registered trademark of Frito-Lay North America, Inc.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
